<template>
  <div id="home">
    <div class="top">
      <div class="top_one">
        <img src="../assets/home/nav_logo.png" alt class="img" @click="hos()" />
        <ul class="top_li">
          <li :class="{active:0==num}" @click="home()">首页</li>
          <li class="products" @click="produ" :class="{active:1==num}">
            <p>
              产品
              <i class="el-icon-arrow-down"></i>
            </p>
            <div class="product">
              <div class="product_s">
                <p class="product-p">
                  <img src="../assets/home/nav_icon_pre03.png" alt />
                </p>
                <div class="product-div">
                  <p class="product-div_p">
                    <img src="../assets/home/nav_icon_pre01.png" alt />
                  </p>
                  <ul>
                    <li><a href="#1" >提升品牌</a></li>
                    <li><a href="#2" >降低成本</a></li>
                    <li><a href="#3">一键转发</a></li>
                    <li><a href="#4" >电子名片</a></li>
                    <li><a href="#5">数据追踪</a></li>
                    <li><a href="#6">智能报表</a></li>
                    <li><a href="#7">智能管理</a></li>
                    <li><a href="#8">员工管理</a></li>
                    <li><a href="#9">智能AI拓客</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li :class="{active:2==num}" @click="solve()">解决方案</li>
          <li :class="{active:3==num}" @click="channel()">渠道合作</li>
          <li class="productsa" @click="adds()" :class="{active:4==num}">
            <p>
              关于我们
              <i class="el-icon-arrow-down"></i>
            </p>
            <div class="producta">
              <div class="producta_s">
                <p class="producta-p">
                  <img src="../assets/home/nav_icon_pre03.png" alt />
                </p>
                <div class="producta-div">
                  <p class="producta-div_p">
                    <img src="../assets/home/nav_icon_pre02.png" alt />
                  </p>
                  <ul>
                    <li @click.stop="add()">企业介绍</li>
                    <li @click.stop="add1()">奖项荣誉</li>
                    <li @click.stop="add2()">新闻资讯</li>
                    <li @click.stop="add3()">联系我们</li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="top_right">
          <el-dropdown>
            <el-button type="primary" class="button bottons" >
              登录
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <a href="https://card.sqifu.com" target="_blank" class="login">企业登录</a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a href="https://card.sqifu.com/admin" target="_blank" class="login1">代理商登录</a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" class="button" @click="helseshi = true">免费使用</el-button>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="helseshi" width="584px">
      <div class="hesll" style="margin-bottom:20px;" >
        <p>现在注册，免费体验</p>
        <p></p>
      </div>
      <el-form
        :inline="true"
        :model="formInline"
        :rules="rules"
        ref="ruleForm"
        class="demo-form-inline"
        style="margin-left:100px;margin-right: 100px"
        label-width="130px"
        hide-required-asterisk
        close-on-press-escape="false"
        close-on-click-modal="false"
      >
          <div class="input">
            <el-form-item label="登录账号" style="margin-left:10px" class="wh" prop="account">
              <el-input class="minaword" type="text" placeholder="请输入账号（同时作为小程序名称）" autocomplete="off" v-model="formInline.account" />
            </el-form-item>
          </div>
        <div class="new_wied"> 登录账号=小程序名称</div>
        <div class="input">
          <el-form-item label="密码" style="margin-left:10px " class="wh" prop="password" >
            <el-input class="minaword" show-password placeholder="请输入登录密码" v-model="formInline.password"  	></el-input>
          </el-form-item>
        </div>
        <div class="input">
          <el-form-item label="确认密码" style="margin-left:10px " class="wh" prop="agenpassword">
            <el-input class="minaword" show-password placeholder="请再次输入登录密码" v-model="formInline.agenpassword"  	></el-input>
          </el-form-item>
        </div>
        <div class="input">
          <el-form-item label="手机号" style="margin-left:10px" class="wh" prop="phone" >
            <el-input class="minaword" type="text" placeholder="请输入您的手机号" v-model="formInline.phone" autocomplete="off"/>
          </el-form-item>
        </div>
<!--        <div class="input linginput">-->
<!--          <el-form-item label="验证码" style="margin-left:10px" class="wh">-->
<!--            <el-input class="minaword" type="text" placeholder="请输入验证码" v-model="formInline.yzhma" >-->
<!--              <template slot="append" class="input-appen"><el-button class="inp-butt" autocomplete="off">获取验证码</el-button></template>-->
<!--            </el-input>-->
<!--          </el-form-item>-->
<!--        </div>-->

<!--        <div class="input">-->
<!--          <el-form-item label="公司名称" style="margin-left:10px" class="wh" prop="mini_name" >-->
<!--            <el-input class="minaword" type="text" placeholder="请输入与营业执照一致的公司名称" v-model="formInline.mini_name" autocomplete="off"/>-->
<!--          </el-form-item>-->
<!--        </div>-->
        <div class="input">
          <el-form-item label="推荐人手机号" style="margin-left:10px" class="wh" prop="agent_phone">
            <el-input class="minaword" type="text" placeholder="如有，则填写" v-model="formInline.agent_phone" autocomplete="off" />
          </el-form-item>
        </div>
          <!-- <div class="input">
            <el-form-item label="验证码" style="margin-left:10px">
              <input type="text" placeholder="请输入验证码" v-model="formInline.name" />
            </el-form-item>
          </div> -->
        <el-form-item>
          <el-button  v-if="fenyed ===1" type="primary" class="buttons" @click="registerd(formInline)">注册并登录</el-button>
          <el-button  v-if="fenyed ===4" type="primary" class="buttons" @click="londin(formInline)">登录</el-button>
          <el-button  v-if="fenyed ===2" type="primary" class="buttons" @click="addsup()">确认修改</el-button>
          <div class="fle_butern">
            <div ></div>
            <div>已有账号，<el-button class="fle-butt" @click="lodnin">直接登录</el-button></div>
          </div>
        </el-form-item>
      </el-form>
      <div class="floor">
        <p>如有疑问，可拨打咨询热线： 022-8821-9596</p>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {getintention_customer_add_sub} from "@/config/api";
import {index_freeTrial } from "@/csconfig/api";
export default {
  name: "app-header",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.formInline.agenpassword !== '') {
          this.$refs.ruleForm.validateField('agenpassword');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.formInline.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var valiphone = (rule, value, callback) =>{
      if (value === '') {
        callback(new Error('手机号不为空'));
      } else if(!(/^1[3456789]\d{9}$/.test(value))){
        callback(new Error("手机号格式错误"))
      }else{
        callback();
      }
    };
    var valiagentphone = (rule, value, callback) =>{
      if (value === '') {
        callback();
      } else if(!(/^1[3456789]\d{9}$/.test(value))){
        callback(new Error("手机号格式错误"))
      }else{
        callback();
      }
    };
    return {
      num: 0,
      helseshi: false,
      formInline: {
        phone: "",
        password:'',
        agenpassword:'',
        account:'',
        agent_phone:'',
      },
      rules: {
        phone: [{ validator: valiphone, trigger: 'blur' },],
        password: [ { validator: validatePass, trigger: 'blur' },],
        agenpassword: [{ validator: validatePass2, trigger: 'blur' },],
        account: [{ required: true,message: '请输入公司名称', trigger: 'blur' },],
        agent_phone:[{ validator: valiagentphone, trigger: 'blur' }]
      },
      options: [],
      defaultParams: {
        label: "name",
        value: "name",
        children: "children"
      },
      zhucdengl:false,
      wangj:true,
      fenyed:1,
      urld:'https://card.sqifu.com/#/login'
    };
  },
  methods: {
    hos(){
      this.num = 0;
      sessionStorage.setItem("num", this.num);
      this.$router.push({
        path: "/"
      });
    },
    home() {
      this.num = 0;
      sessionStorage.setItem("num", this.num);
      this.$router.push({
        path: "/"
      });
    },
    solve() {
      this.num = 2;
      sessionStorage.setItem("num", this.num);
      this.$router.push({
        path: "/solve"
      });
    },
    channel() {
      this.num = 3;
      sessionStorage.setItem("num", this.num);
      this.$router.push({
        path: "/channel"
      });
    },
    produ() {
      this.num = 1;
      sessionStorage.setItem("num", this.num);
      this.$router.push({
        path: "/product"
      });
    },
    addsup() {
      this.formInline.application_area = this.formInline.application_area.toString();
      getintention_customer_add_sub(this.formInline).then(res => {
        if (res.data.code == 200) {
          this.$message({
            message: "申请成功",
            type: "success"
          });
          window.location.href = this.urld

        }
      });
    },
    //注册并登录
    registerd (formInline) {
      var that = this
      var formInline = that.formInline
      var urld = this.urld
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          index_freeTrial(formInline).then(res =>{
            if (res.data.code == 200) {
              this.$message({
                message: "申请成功",
                type: "success"
              });
              this.helseshi = false;
              urld = urld + '?account=' + formInline.account + '&password=' + formInline.password
              window.location.href = urld
            }
            if(res.data.code ===400){
              this.$message({
                message: res.data.error,
                type: 'error'
              });
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    //登录
    londin(formInline){

    },
    //优质服务商
    getManagement() {
      this.$http(
        "https://www.newcoc.cn/WebProgram/WebApi/getRegionList",
        "post"
      ).then(res => {
        this.options = res.data.data;
      });
    },
    handleChange(value) {
      let labels = this.$refs["cascaderAddr"].currentLables;
    },
    add() {
      this.num = 4;
      sessionStorage.setItem("num", this.num);
      this.$router.push({
        path: "/about",
        query: {
          numm: 0
        }
      });
      this.$router.go(0)
    },
    add1() {
      this.num = 4;
      sessionStorage.setItem("num", this.num);
      this.$router.push({
        path: "/about",
        query: {
          numm: 1
        }
      });
      this.$router.go(0)
    },
    add2() {
      this.num = 4;
      sessionStorage.setItem("num", this.num);
      this.$router.push({
        path: "/about",
        query: {
          numm: 2
        }
      });
      this.$router.go(0)
    },
    add3() {
      this.num = 4;
      sessionStorage.setItem("num", this.num);
      this.$router.push({
        path: "/about",
        query: {
          numm: 3
        }
      });
      this.$router.go(0)
    },
    adds() {
      this.num = 4;
      sessionStorage.setItem("num", this.num);
      this.$router.push({
        path: "/about",
        query: {
          numm: 0
        }
      });
    },
    forget () {
      this.zhucdengl = true
      this.wangj = false
      this.fenyed = 2
    },
    lodnin () {
      this.zhucdengl = false
      this.wangj = true
      this.fenyed = 1
      window.location.href = this.urld
    },
    registersd () {
      this.zhucdengl = true
      this.wangj = true
      this.fenyed = 0
    }
  },
  created() {
    this.getManagement();
    this.num = sessionStorage.getItem("num");
    this.$emit("footer", true); //是否显示头部
  }
};
</script>

<style scoped>
@import "style.css";
@import "style1.css";

.tsheng{
  position: relative;
  z-index: 200;
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

#home {
  width: 100%;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #2b2f33;
  position: fixed;
  z-index: 99;
}

.top_one {
  width: 1200px;
  margin: 0 auto;
}

.img {
  width: 200px;
  height: 40px;
  padding: 10px 57px 15px 0;
  float: left;
  cursor: pointer;
}

.top_li li {
  float: left;
  line-height: 65px;
  color: #fff;
  margin-right: 43px;
  cursor: pointer;
}

.top_li li.active {
  color: #337eff;
}

.top_li li:hover {
  color: #337eff;
}

.top_right {
  float: right;
  line-height: 65px;
}

.button {
  width: 90px;
  height: 33px;
  line-height: 0;
  padding: 0;
}

.bottons {
  background: transparent;
  color: #409eff;
  border: 1px solid #409eff;
}

.bottons:hover {
  background: transparent;
}

.add {
  margin-left: 5px;
}
.products,
.productsa {
  position: relative;
}

.product {
  width: 100%;
  position: absolute;
  display: none;
  left: 0;
  z-index: 99;
}

.product_s {
  width: 558px;
  height: 192.3px;
  margin-left: -260px;
}

.products:hover .product {
  display: block;
}

.product-p {
  width: 21px;
  height: 10px;
  margin: 0 auto;
  line-height: 0;
}

.product-div {
  width: 558px;
  height: 182.3px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(225, 230, 240, 1);
  border-radius: 10px;
}

.product-div_p {
  width: 212px;
  height: 182.3px;
  background: #f1f4f8;
  border-radius: 10px 0px 0px 10px;
  float: left;
}

.product-div_p img {
  margin: 20px;
}

.product-div ul {
  width: 346px;
  height: 80px;
  float: left;
}

.product-div ul li {
  margin-left: 38px;
  color: #666666;
  margin-top: 45px;
  line-height: 0;
  font-size: 14px;
  margin-right: 0;
}

.product-div ul li a{
  color: #666666;
  text-decoration: none;
}

.producta {
  width: 100%;
  position: absolute;
  display: none;
  left: 0;
  z-index: 99;
}

.producta_s {
  width: 450px;
  height: 192.3px;
  margin-left: -190px;
}

.productsa:hover .producta {
  display: block;
}

.producta-p {
  width: 21px;
  height: 10px;
  margin: 0 auto;
  line-height: 0;
}

.producta-div {
  width: 450px;
  height: 182.3px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(225, 230, 240, 1);
  border-radius: 10px;
}

.producta-div_p {
  width: 212px;
  height: 182.3px;
  background: #f1f4f8;
  border-radius: 10px 0px 0px 10px;
  float: left;
}

.producta-div_p img {
  margin: 20px;
}

.producta-div ul {
  width: 238px;
  height: 80px;
  float: left;
  margin-top: 26px;
}

.producta-div ul li {
  margin-left: 38px;
  color: #666666;
  margin-top: 45px;
  line-height: 0;
  font-size: 14px;
  margin-right: 0;
}

.hesll {
  text-align: center;
}

.hesll p:first-child {
  font-size: 34px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 12px;
}

.hesll p:last-child {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(159, 161, 159, 1);
}

.input {
  width: 384px;
  height: 40px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(215, 215, 219, 1);
  border-radius: 4px;
  margin-bottom: 20px;
}

.input input {
  border: 0;
  outline: 0;
}

.buttons {
  width: 384px;
  height: 40px;
}

.floor {
  width: 100%;
  height: 54px;
  background: rgba(241, 244, 248, 1);
  border-radius: 0px 0px 10px 10px;
  margin-top: 30px;
}

.floor p {
  text-align: center;
  line-height: 54px;
  color: #98abc1;
}

.links {
  width: 90px;
  height: 32px;
  border: 1px solid rgba(51, 125, 255, 1);
  border-radius: 4px;
}

.login {
  padding: 5px 10px;
  text-decoration: none;
  color: #666666;
}
.login1 {
  padding: 5px 10px;
  text-decoration: none;
  color: #666666;
}
.demo-form-inline>>>.el-form-item__label{
  padding-left: 10px;
  color: #333333;
  text-align: left;
}

.minaword >>>.el-input__inner{
  width: 240px;
  border: 0;
}
.linginput .minaword>>>.el-input__inner{
  width: 131px;
}
.linginput .minaword>>>.el-input-group__append{
  width: 39px;
}
.wh{
  width: 100%;
}
.minaword>>>.el-input__suffix{
  display: block !important;
}
.flex{
  display: flex;
}
.maut{
  margin: auto;
}
.fkexcent{
  display: flex;
  justify-content: center
}
.c-bule{color: #337EFF}
.ml10{
  margin-left: 10px;
}
.inp-butt{
  color: #337EFF !important;
  text-align: center;
  margin: 0px auto;
}
.input-appen{
  width: 10px!important;
}
.fle_butern{
  display: flex;
  justify-content:space-between
}
.fle-butt{
  border: none;
  color: #337EFF;
}
>>>.el-form--inline .el-form-item__content{
  /*width: ;*/
}
.new_wied{
  background: #FFE5DB;
  color: #FF5614;
  padding: 3px 20px;
  border-radius: 10px;
  width: auto;
  display: inline-block;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue